import React from 'react';
import axios from 'axios';
import hyperid from 'hyperid';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Form, ErrorMessage } from 'formik';
import { camelCase } from 'change-case';
import { get, isString, size } from 'lodash';
import md5 from 'md5';
import { map } from 'lodash';
import { checkLogicalAnswer, processQuestionsAnswers, processQuestionsAnswersNew, isAlternative, GetFlagCountryCode } from './utils';
import { questionTypes } from './shared/GeneralQuestionnaire';
import GeneralQuestionnaireApp from './shared/GeneralQuestionnaireApp';
import Select from 'react-select';
import './App.css';
import { COUNTRIES_WITH_CODE } from './constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import PhoneInput from 'react-phone-number-input';
import EventForm from './pages/eventInitialRegistration/eventForm';
const appFontSize = {
  fontSize: '1.125rem !important',
};

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process?.env;

class App extends React.Component {
  constructor(props) {
    super(props);

    const parsedQueryString = queryString.parse(window.location.search);
    this.eventId = parseInt(parsedQueryString.eventId, 10);
    this.siteId = parseInt(parsedQueryString.siteId, 10);
    this.queryEmail = parsedQueryString?.email || '';
    this.employeeId = parseInt(parsedQueryString.employeeId, 10);
    this.language = parsedQueryString.language || 'en';

    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    this.state = {
      hosts: [],
      suggestedHosts: [],
      selectedHost: '',
      selectedHostDetails: undefined,
      selectedCountry: '',
      selectedCountryDetails: undefined,
      skippedToLast: false,
      selectedVisitorType: {
        template: undefined,
        typeId: undefined,
        print: undefined,
        isScanTemperature: undefined,
      },
      filteredQuestions: [],
      initialValues: {
        name: '',
        mobilePhoneNumber: '',
        phone: '',
        email: '',
        company: '',
        nameOfHost: '',
        entryType: '',
      },
      userName: '',
      isResultModal: false,
      selectedStage: 0,
      paginationMax: 3,
      activeInput: '',
      disabledNextState: false,
      errorCheck: false,
      sites: [],
    };
    this.answersMap = new Map();
    this.instance = hyperid();
    this.formData = new FormData();

    this.formData.set('template', undefined);
    this.formData.set('typeId', undefined);
    this.formData.set('siteId', this.siteId);
    this.formData.set('accountId', -1);
    this.ref = React.createRef();
    this.ref.current = { lastPages: [] };
  }

  async getSites(accountId) {
    var config = {
      method: 'get',
      url: `${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/getSitesAll?accountId=${accountId}`,
    };

    const { data } = await axios(config);
    return data.sites;
  }

  async getEventDetails(eventId) {
    var config = {
      method: 'get',
      url: `${REACT_APP_MY_LOBBY_BACKEND_URL}/api/events/getEvent/${eventId}`,
    };

    const { data } = await axios(config);
    return data.event;
  }

  async componentDidMount() {
    this.session = await this.initSession();
    this.site = await this.initSiteDetails();
    this.host = await this.initHost();
    for (var i = 0; i < this.site.visitorTypes.length; i++) {
      if (this.site.visitorTypes[i].mobile === undefined) {
        this.site.visitorTypes[i].mobile = true;
      }
    }
    this.sites = await this.getSites(this.site.accountId);
    const enabledVisitorTypes = this.site.visitorTypes.filter((v) => {
      return v.state === true && v.mobile === true && v.template !== '1' && v.template !== 1;
    });
    if (this.eventId) {
      this.eventDetails = await this.getEventDetails(this.eventId);
    }

    this.setState({
      site: this.site,
      sites: this.sites,
      hosts: this.host.data.employees,
      suggestedHosts: this.host.data.employees,
      visitorTypes: enabledVisitorTypes,
      purposes: this.site.purposes,
    });
    if (this.eventId && this.queryEmail) {
      const currentGuest = this.eventDetails?.guests?.find((g) => g?.email == this.queryEmail?.replace(' ', '+'));
      if (!currentGuest || Object.keys(currentGuest).length <= 0) {
        this.props.history.push('/event-no-email-found');
        this.props.hideLoader();
        return;
      }
      const entryType = currentGuest?.inviteetype || '';
      const e = { target: { value: entryType } };
      this.handleEntryTypeChange(undefined, true, e);
    }

    this.props.hideLoader();
    // console.log('state.site', this.state.site);
  }

  async initSession() {
    const id = this.instance.uuid;
    await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: this.siteId,
    });
    const login = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/login`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: this.siteId,
    });
    return login.data;
  }

  initHost() {
    return axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/host?siteId=${this.siteId}&accountId=${this.site.accountId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.session.id,
      },
    });
  }

  async initSiteDetails() {
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/${this.siteId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.session.id,
      },
    });
    return data.site;
  }

  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : this.state.hosts.filter((host) => host.name.toLowerCase().slice(0, inputLength) === inputValue);
  };

  getSuggestionsCountry = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : COUNTRIES_WITH_CODE.filter((country) => country.value.toLocaleLowerCase().slice(0, inputLength) === inputValue);
  };

  getSuggestionValue = (suggestion) => suggestion.name;

  renderSuggestion = (suggestion) => (
    <div className="bg-white border border-gray-400 p-3">
      {/* <div className="divide-y divide-blue-300"> */}
      <span className="text-lg truncate text-gray-800">{suggestion.name}</span>
      {/* </div> */}
    </div>
  );

  handleEntryTypeChange = async (setFieldValue, flag, e) => {
    this.answersMap.clear();
    this.ref.current.lastPages.push(0);
    const { value } = e.target;
    const [visitorType] = this.state.visitorTypes.filter((v) => v.name === value);

    if (visitorType !== undefined) {
      let updatedQuestions = [];
      const initialValues = this.state.initialValues;
      if (this.state.site.isEnableIfThenQuestionnaire && this.state.site.pagination) {
        const logicalQuestionnaire = (this.state.site.logicalQuestionnaire || []).find((q) => q.visitorTypes.includes(visitorType.roleId));
        if (logicalQuestionnaire) {
          updatedQuestions = logicalQuestionnaire.logicalQuestions.map((lq) => {
            const q = lq.question;
            const label = isString(get(q, 'label')) ? q.label : get(q, `label[${this.language}]`) || '';
            const hashedLabel = md5(camelCase(label || ''), {
              algorithm: 'md5',
            });
            q.inputName = `question_inputN_${q.uuid || q.inputN}_${hashedLabel}`;
            return { ...lq, question: q };
          });
          this.setState({ site: { ...this.state.site } });
        } else {
          updatedQuestions = this.getGeneralQuestionnaire(visitorType);
          this.setState({ site: { ...this.state.site, isEnableIfThenQuestionnaire: false } });
        }
      } else {
        this.setState({ site: { ...this.site, isEnableIfThenQuestionnaire: false } });
        updatedQuestions = this.getGeneralQuestionnaire(visitorType);
        this.setState({ site: { ...this.state.site, isEnableIfThenQuestionnaire: false } });
      }
      updatedQuestions.forEach((q) => {
        if (q.type === questionTypes.TEXT) {
          initialValues[q.inputName] = '';
        }
        if (q.type === questionTypes.RADIOBUTTON) {
          initialValues[q.inputName] = this?.state?.site?.mandatoryAnswersToQuestions === false ? false : null;
        }

        if (q.type === questionTypes.NUMBER) {
          initialValues[q.inputName] = this?.state?.site?.mandatoryAnswersToQuestions === false ? 0 : null;
        }
      });

      this.setState({
        filteredQuestions: [...updatedQuestions],
        selectedVisitorType: visitorType,
        initialValues,
      });
      this.formData.set('typeId', visitorType.id);
      this.formData.set('roleId', visitorType.roleId);
      this.setState({
        paginationMax: 3 + Math.round(updatedQuestions.length / 2),
      });
    }

    setFieldValue && (await setFieldValue('entryType', value));
    if (flag) {
      document.getElementById(this.state.selectedStage).classList.remove('active');
      let selectPage = this.state.selectedStage + 1;
      if (this.site && this.eventId && this.queryEmail) {
        selectPage = 3;
      }
      this.setState({ selectedStage: selectPage });
      document.getElementById(selectPage.toString()).classList.add('active');
    }
  };

  getGeneralQuestionnaire = (visitorType) => {
    const questions = this.state.site.questions.map((q) => {
      const label = isString(get(q, 'label')) ? q.label : get(q, `label[${this.language}]`) || '';
      const hashedLabel = md5(camelCase(label || ''), {
        algorithm: 'md5',
      });
      q.inputName = `question_inputN_${q.uuid || q.inputN}_${hashedLabel}`;
      return q;
    });
    const qV = questions.filter((q) => q.visitorTypes.includes(visitorType.roleId));
    var qD = [];
    for (var v = 0; v < qV.length; v++) {
      if (qV[v].device && qV[v].device.mobile === true) {
        qD.push(qV[v]);
      }
    }
    if (qD.length > 0) {
      return qD;
    }
    return qV;
  };

  parseImageStringFromDataUrl = (dataUrl) => {
    const splittedData = dataUrl.split('data:image/png;base64,');
    return splittedData[1];
  };
  handleEventRegistration = async (values) => {
    for (const property in values) {
      if (property.includes('question_inputN_')) {
        this.answersMap.set(property, values[property]);
        this.formData.delete(property);
      }
    }
    let responsePageBuilderData = null;
    let ques = [];
    let isResultModal = false;
    let success = true;
    let isAlt = false;

    if (this.state.filteredQuestions.length > 0) {
      let formattedAnswers = this.state.site.isEnableIfThenQuestionnaire
        ? processQuestionsAnswersNew(this.answersMap, this.state.filteredQuestions)
        : processQuestionsAnswers(this.answersMap, this.state.filteredQuestions);

      formattedAnswers.some((item) => {
        if (this.state.site.isEnableIfThenQuestionnaire) {
          if (item.no.type == 'RESPONSE') {
            responsePageBuilderData = item.no.data;
            return true;
          }
        } else {
          if (Number(item.answer) === item.notification && (item.type === 1 || item.type === 3)) {
            isResultModal = true;
            return true;
          }
        }

        return false;
      });
      formattedAnswers = formattedAnswers.map((fa) => {
        return this.state.site.isEnableIfThenQuestionnaire ? fa.question : fa;
      });

      //let check show code or not
      formattedAnswers.some((item) => {
        if (item.type === 3) {
          console.log(item.answer);
        }
        if (Number(item.answer) === item.notification && (item.type === 1 || item.type === 3)) {
          success = false;
          return true;
        }
        return false;
      });
      ques = formattedAnswers;
    }
    const eventPaymentId = uuidv4();

    const payload = {
      // company: values?.company || '',
      // doorAccess: false,
      email: this.queryEmail.replace(' ', '+') || '',
      id: this.eventId,
      // inviteetype: values?.entryType || '',
      // name: values?.name || '',
      // phone: values?.phone || '',
      // registrationType: values?.purposeOfVisit || '',
      // paymentStatus: false,
      answers: ques || [],
      eventPaymentId: eventPaymentId,
    };
    axios
      .post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/events/registerInvite`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: this.session.id,
        },
      })
      .then((result) => {
        sessionStorage.setItem(
          'submitedData',
          JSON.stringify({
            eventDetails: this.eventDetails || {},
            paymentLink: this.eventDetails.paymentLink || '',
            pageData: responsePageBuilderData,
            eventPaymentId: eventPaymentId,
          }),
        );
        this.props.history.push('/event-response');
      })
      .catch((err) => {
        toast.error(err.response.data.error.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  handleFormSubmit = async (values) => {
    if (this.eventId) {
      // console.log("values",values)
      this.handleEventRegistration(values);
      return;
    }
    for (const property in values) {
      if (property === 'mobilePhoneNumber') {
        values[property] = values['phone'];
      }
      this.formData.set(property, values[property]);

      if (property.includes('question_inputN_')) {
        this.answersMap.set(property, values[property]);
        this.formData.delete(property);
      }
    }

    this.setState({
      ...this.state,
      userName: values.name,
    });
    let responsePageBuilderData = null;
    let isResultModal = false;
    let success = true;
    let isAlt = false;
    if (this.state.filteredQuestions.length > 0) {
      let formattedAnswers = this.state.site.isEnableIfThenQuestionnaire
        ? processQuestionsAnswersNew(this.answersMap, this.state.filteredQuestions)
        : processQuestionsAnswers(this.answersMap, this.state.filteredQuestions);
      formattedAnswers.some((item) => {
        if (this.state.site.isEnableIfThenQuestionnaire) {
          if (checkLogicalAnswer(item, item.question.answer)) {
            isResultModal = true;
            let key = item.question.answer === true ? 'yes' : 'no';
            if (item.default) key = 'no';
            responsePageBuilderData = item[key].data;
            if (isAlternative(item)) {
              isAlt = true;
              responsePageBuilderData = item.question.mobile;
            }
            return true;
          }
        } else {
          if (Number(item.answer) === item.notification && (item.type === 1 || item.type === 3)) {
            isResultModal = true;
            return true;
          }
        }

        return false;
      });
      formattedAnswers = formattedAnswers.map((fa) => {
        return this.state.site.isEnableIfThenQuestionnaire ? fa.question : fa;
      });

      //let check show code or not
      formattedAnswers.some((item) => {
        if (item.type === 3) {
          console.log(item.answer);
        }
        if (Number(item.answer) === item.notification && (item.type === 1 || item.type === 3)) {
          success = false;
          return true;
        }
        return false;
      });

      this.formData.set('answers', JSON.stringify(formattedAnswers));
      console.log({ formattedAnswers });
    }

    this.formData.set('template', this.state?.selectedVisitorType?.template);
    this.formData.set('typeId', this.state?.selectedVisitorType?.id);
    this.formData.set('accountId', this.state?.site?.accountId);
    this.formData.set('employeeId', this.state?.selectedHostDetails?.id);
    this.formData.set('employeeIds', JSON.stringify(this.state?.selectedHosts));

    axios
      .post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/signin?siteId=${this.siteId}`, this.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: this.session.id,
        },
      })
      .then((result) => {
        if (Number(this.state.selectedVisitorType.template) === 7) {
          success = false;
        }
        if (isAlt) {
          success = true;
        }

        if (result && result.data && result.data.visitorId) {
          sessionStorage.setItem(
            'submitedData',
            JSON.stringify({
              name: values.name,
              siteName: this.state.site.name,
              inviteCode: result.data.visitorId.inviteCode,
              success: success,
              isEnableQrCodeWithPinInside: this.state.site.isEnableQrCodeWithPinInside,
              isScanTemperature: this.state.selectedVisitorType.isScanTemperature,
              pageData: responsePageBuilderData,
            }),
          );

          this.setState({
            ...this.state,
            isResultModal: isResultModal,
          });
        }
        sessionStorage.setItem('redirectType', JSON.stringify({ redirectType: this.state.selectedVisitorType?.name }));
        // if (this.state.selectedVisitorType.template === 7) {
        //   this.props.history.push('/finished');
        //   return;
        // }
        if (!this.state.site.isEnableIfThenQuestionnaire) {
          if (!isResultModal && (this.state.selectedVisitorType.isScanTemperature || this.state.selectedVisitorType.print)) {
            this.props.history.push('/submitted');
          } else if (!isResultModal && !this.state.selectedVisitorType.isScanTemperature && !this.state.selectedVisitorType.print) {
            sessionStorage.setItem('confirmationPageMessage', JSON.stringify(this.state.site?.confirmationPageMessage));
            this.props.history.push('/withouttemperature');
          } else if (isResultModal) {
            this.props.history.push('/rejected');
          }
        } else {
          if (this.state.selectedVisitorType.isScanTemperature || this.state.selectedVisitorType.print) {
            this.props.history.push('/response');
          } else {
            this.props.history.push('/responsewithouttemperature');
          }
        }
      })
      .catch((err) => {
        toast.error(err.response.data.error.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
    //no need to show code if pre registration
  };

  onSuggestionChange = (setFieldValue, event, suggestionProps) => {
    setFieldValue('nameOfHost', suggestionProps.suggestionValue);
    const [hostDetails] = this.state.hosts.filter((item) => item.name === suggestionProps.suggestionValue);
    this.setState({
      selectedHost: suggestionProps.suggestionValue,
      selectedHostDetails: hostDetails,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestedHosts: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestedHosts: [],
    });
  };

  buildValidationSchema = (questions, hasPurposes) => {
    if (this.site && this.eventId && this.queryEmail) {
      return Yup.object().shape({});
    }

    let visitorSignInSchema = Yup.object().shape(
      hasPurposes
        ? {
            name: Yup.string().required('Your name is required'),
            purposeOfVisit: Yup.string().required('The purpose of visit is required'),
            entryType: Yup.string().required('The entry type is required'),
          }
        : {
            name: Yup.string().required('Your name is required'),
            phone: this.phoneValueScheme(),
            email: Yup.string().email(),
            // .required('Your email address is required'),
            company: this.companyValueScheme(),
            nameOfHost: Yup.string().required('The host name you visit is required'),
            entryType: Yup.string().required('The entry type is required'),
          },
    );

    if (questions.length === 0) {
      return visitorSignInSchema;
    }

    let questionsSchema = [];
    if (!this.state.skippedToLast) {
      questionsSchema = questions.map((lq) => {
        const q = this.state.site.isEnableIfThenQuestionnaire ? lq.question : lq;
        if (q.type === questionTypes.RADIOBUTTON) {
          if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
            return [q.inputName, Yup.boolean().required('Please answer the question').nullable()];
          } else {
            return [q.inputName, Yup.boolean().nullable()];
          }
        }

        if (q.type === questionTypes.NUMBER) {
          if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
            return [q.inputName, Yup.number().required('Please answer the question').nullable()];
          } else {
            return [q.inputName, Yup.number().nullable()];
          }
        }

        if (q.type === questionTypes.NONRESPONSE) {
          if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
            return [Yup.number().notRequired()];
          }
          return [q.inputName, Yup.number().notRequired()];
        }

        if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
          return [q.inputName, Yup.string().required('Please answer the question').nullable()];
        } else {
          return [q.inputName, Yup.string().nullable()];
        }
      });
    }

    for (let i = 0; i < questions.length; i++) {
      visitorSignInSchema = Yup.object()
        .shape(
          hasPurposes
            ? {
                name: Yup.string().required('Your name is required'),
                purposeOfVisit: Yup.string().required('The purpose of visit is required'),
                entryType: Yup.string().required('The entry type is required'),
              }
            : {
                name: Yup.string().required('Your name is required'),
                phone: this.phoneValueScheme(),
                email: Yup.string().email(),
                // .required('Your email address is required'),
                company: this.companyValueScheme(),
                nameOfHost: Yup.string().required('The host name you visit is required'),
                entryType: Yup.string().required('The entry type is required'),
              },
        )
        .shape(Object.fromEntries(questionsSchema));
    }

    return visitorSignInSchema;
  };

  companyValueScheme = () => {
    if (this?.state?.site?.mandatoryCompanyName && (this?.state?.site?.displayCompany || this?.state?.site?.displayCompany === undefined)) {
      return Yup.string().required('Your company name is required');
    }
    return Yup.string();
  };

  phoneValueScheme = () => {
    if (this?.state?.site?.mandatoryPhoneNumber) {
      return Yup.string().required('Your mobile phone is required').nullable();
    }
    return Yup.string().nullable();
  };

  onResultModalSubmit = () => {
    this.setState({
      ...this.state,
      isResultModal: false,
    });

    // this.props.history.push('/submitted');
  };

  onNextClick = (values) => {
    if (
      (this.state.site.displayCompany && this.state.site.mandatoryCompanyName && values['company'] === '') ||
      (this.state.site.displayPhoneNumber && this.state.site.mandatoryPhoneNumber && values['phone'] === '')
    ) {
      this.setState({
        errorCheck: true,
      });
    } else {
      this.setState({
        errorCheck: false,
      });
      const selectedPage = this.state.site.isEnableIfThenQuestionnaire ? this.getNextPageBasedOnAnswer(this.state.selectedStage) : this.state.selectedStage + 1;
      const isPurposeOfVisitTypeTemplate = Number(this.state.selectedVisitorType?.template) === 6;
      if (selectedPage === 3 && values['nameOfHost'] === '' && !isPurposeOfVisitTypeTemplate) {
        this.setState({
          errorCheck: true,
        });
      } else {
        this.setPage(selectedPage);
      }
    }
  };

  getNextPageBasedOnAnswer = (currentIndex) => {
    this.setState({ activeInput: '' });
    let index = currentIndex;
    console.log(this.state.selectedVisitorType);
    const hasPurpose = Number(this.state.selectedVisitorType?.template) === 6;
    let mandatoryQuestionsBeforeQuestionnaire = hasPurpose ? (Boolean(size(this.state.purposes)) ? 3 : 2) : 3;
    if (currentIndex >= mandatoryQuestionsBeforeQuestionnaire) {
      const { values } = this.formik;
      const questionIndex = currentIndex - mandatoryQuestionsBeforeQuestionnaire;
      const questionWrapper = this.state.filteredQuestions[questionIndex];
      const { question } = questionWrapper;
      if (questionWrapper.default) {
        if (questionWrapper['no'].type === 'QUESTION') {
          console.log('go to next question');
          index = this.getQuestionIndexBasedOnUuid(questionWrapper['no'].data) + mandatoryQuestionsBeforeQuestionnaire - 1;
        } else {
          console.log('go to response page');
          this.setState({ skippedToLast: true });
          index = this.state.paginationMax - 2;
        }
      } else {
        const inputKey = question.inputName;
        const response = values[inputKey] || false;
        const responseEnumKey = response ? 'yes' : 'no';

        if (questionWrapper[responseEnumKey].type === 'QUESTION') {
          console.log('go to next question');
          index = this.getQuestionIndexBasedOnUuid(questionWrapper[responseEnumKey].data) + mandatoryQuestionsBeforeQuestionnaire - 1;
        } else {
          console.log('go to response page');
          this.setState({ skippedToLast: true });
          index = this.state.paginationMax - 2;
        }
      }
    }
    this.setState({ lastPage: currentIndex }); //saving lastPage
    this.ref.current.lastPages.push(currentIndex);
    return index + 1;
  };

  getQuestionIndexBasedOnUuid = (uuid) => {
    const qIndex = this.state.filteredQuestions.findIndex((lq) => lq.uuid === uuid);
    if (
      this?.state?.site?.mandatoryAnswersToQuestions &&
      this.state?.filteredQuestions[qIndex]?.question?.inputName &&
      this.state?.filteredQuestions[qIndex]?.question?.type !== 4
    ) {
      this.setState({ activeInput: this.state?.filteredQuestions[qIndex]?.question?.inputName });
    }
    if (this.state?.filteredQuestions[qIndex]?.question?.type === 5 || this.state?.filteredQuestions[qIndex]?.question?.type === 6) {
      this.setState({ activeInput: this.state?.filteredQuestions[qIndex]?.question?.inputName });
    }
    return qIndex;
  };

  onPrevClick = () => {
    this.setState({ activeInput: '' });
    let selectedPage;
    if (this.state.site.isEnableIfThenQuestionnaire) {
      selectedPage = this.ref.current.lastPages.pop();
      this.setState({ lastPage: null, skippedToLast: false });
    } else {
      selectedPage = this.state.selectedStage - 1;
    }
    this.setPage(selectedPage);
  };

  setPage(number) {
    const pages = document.querySelectorAll('.questionPart');
    const hasPurpose = Number(this.state.selectedVisitorType?.template) === 6;
    let mandatoryQuestionsBeforeQuestionnaire = hasPurpose ? (Boolean(size(this.state.purposes)) ? 3 : 2) : 3;
    this.setState({ paginationMax: pages.length, selectedStage: number });
    pages.forEach((page, index) => {
      if (this.state.filteredQuestions[number - mandatoryQuestionsBeforeQuestionnaire]?.device?.mobile === false) {
        number++;
      }
      if (index === number) {
        page.classList.add('active');
      } else {
        page.classList.remove('active');
      }
    });
  }

  handleInputChange = (query, { action }) => {
    if (action === 'input-change') {
      this.setState({ openMenu: true });
    }
  };
  hideMenu = () => {
    this.setState({ openMenu: false });
  };

  render() {
    const { t } = this.props;
    const { site, filteredQuestions, selectedVisitorType, initialValues, visitorTypes, openMenu } = this.state;

    if (site === undefined)
      return (
        <div className="container w-full max-w-xs mx-auto">
          <p className="text-center mt-4">Loading...</p>
        </div>
      );
    const siteLogoUrl = `${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/getLogo/${this.siteId}?small=true&access_token=${this.session.id}` || '';
    const isPurposeOfVisitTypeTemplate = Number(selectedVisitorType?.template) === 6;
    const isPreRegisterWorkFLow = Number(selectedVisitorType?.template) === 7;
    // console.log('this.state', this.state);

    // Render Event Register Form
    if (site && this.eventId && !this.queryEmail) {
      return (
        <EventForm
          site={site}
          t={t}
          siteLogoUrl={siteLogoUrl}
          visitorTypes={this.state.visitorTypes}
          eventId={this.eventId}
          token={this.session.id}
          history={this.props.history}
        />
      );
    }

    // FORM WITH PAGINATION
    return (
      <div className="container max-w-xs mx-auto">
        <ToastContainer />
        <Formik
          initialValues={initialValues}
          validationSchema={() =>
            Yup.lazy((values) => {
              return this.buildValidationSchema(filteredQuestions, isPurposeOfVisitTypeTemplate);
            })
          }
          onSubmit={(values, actions) => {
            actions.setSubmitting(true);
            this.handleFormSubmit(values);
          }}
          innerRef={(p) => (this.formik = p)}
        >
          {({ errors, touched, values, handleChange, handleBlur, setFieldValue, isSubmitting }) => {
            let disabledNext = false;
            if (this.state.activeInput && (errors[this.state.activeInput] || values[this.state.activeInput] === undefined || values[this.state.activeInput] === null)) {
              disabledNext = true;
            }
            if (this?.state?.site?.pagination) {
              return (
                <Form className={`full-window bg-white px-8 pt-6 pb-8 mb-4 text-white`}>
                  <div id={0} className={'questionPart active'}>
                    <h1 className="text-lg text-black font-bold text-center mt-4">
                      {t('WELCOME TO')}
                      <br />
                      {site.name || ''}
                    </h1>
                    <div className="p-2">
                      <img className="mx-auto h-24 object-center" src={siteLogoUrl} alt={site.name || ''} />
                    </div>
                    {!this.eventId && !this.site.mylobbyLite && (
                      <div className="mb-4">
                        <label className="block text-sm text-black font-bold mb-2" htmlFor="country">
                          Step 1: Choose a site
                        </label>
                        <Select
                          value={{ value: site.id, label: site.name }}
                          name="site"
                          options={this.state.sites.map((s) => {
                            return { label: s.name, value: s.id };
                          })}
                          onChange={(option) => {
                            if (option.value !== this.site.id) {
                              this.props.history.push(`/?siteId=${option.value}`);
                              window.location.reload();
                            }
                          }}
                          styles={{
                            singleValue: (provided) => ({
                              ...provided,
                              color: 'white',
                              fontSize: 15,
                              backgroundColor: '#4379bc',
                              fontWeight: 'bold',
                            }),
                            control: (styles) => ({ ...styles, color: 'white', fontSize: 15, backgroundColor: '#4379bc', fontWeight: 'bolder' }),
                            option: (styles) => ({ ...styles, color: 'white', fontSize: 15, backgroundColor: '#4379bc', fontWeight: 'bolder' }),
                          }}
                        />
                      </div>
                    )}
                    <div className="text-lg text-black mb-4 text-center">
                      What type of {this.eventId ? 'Event Participant ' : 'visitor '}are you?
                      <br />
                      <br />
                      <div className="visitorTypes">
                        {visitorTypes.map((v) => (
                          <button
                            type="button"
                            name="entryType"
                            className={'w-full py-2 mb-2 rounded-lg visitorBtn'}
                            onClick={this.handleEntryTypeChange.bind(this, setFieldValue, true)}
                            id="entryType"
                            key={v.roleId}
                            data-visitor-type-role-id={v.roleId}
                            value={v.name}
                          >
                            {v.name}
                          </button>
                        ))}
                      </div>
                      <br />
                      <br />
                      <div style={{ fontStyle: 'italic' }}>Ensure your browser can access your camera and upload files.</div>
                    </div>
                  </div>

                  <div id={1} className={'questionPart'}>
                    <h1 className="text-base font-bold text-black text-center mt-4">Tell us about yourself.</h1>
                    <br />
                    <div className="mb-4">
                      <label className="block text-sm text-black font-bold mb-2" htmlFor="name">
                        Name
                      </label>
                      <input
                        className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                          errors.name && touched.name ? 'border-red-500' : ''
                        }`}
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                      />
                      {!touched.name && this.state.errorCheck && <p className="text-red-500 font-black text-sm">{errors['name']}</p>}
                      <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="name" />
                    </div>
                    {site.visitor_email && !isPurposeOfVisitTypeTemplate ? (
                      <div className="mb-4">
                        <label className="block text-sm text-black font-bold mb-2" htmlFor="email">
                          {t('Email')}
                        </label>
                        <input
                          className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                            errors.email && touched.email ? 'border-red-500' : ''
                          }`}
                          id="email"
                          name="email"
                          type="email"
                          placeholder="Email address"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                        />
                        <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="email" />
                      </div>
                    ) : null}
                    {site.displayCompany && !isPurposeOfVisitTypeTemplate && (
                      <div className="mb-4">
                        <label className="block text-sm text-black font-bold mb-2" htmlFor="company">
                          Company
                        </label>
                        <input
                          className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                            errors.company && touched.company ? 'border-red-500' : ''
                          }`}
                          id="company"
                          name="company"
                          type="text"
                          placeholder="Company name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.company}
                        />
                        {site.mandatoryCompanyName && !touched.company && this.state.errorCheck && <p className="text-red-500 font-black text-sm">{errors['company']}</p>}
                        <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="company" />
                      </div>
                    )}
                    {site.displayPhoneNumber && !isPurposeOfVisitTypeTemplate && (
                      <div className="mb-4">
                        <label className="block text-sm text-black font-bold mb-2" htmlFor="phone">
                          Phone Number with Country Code <span style={{ color: 'grey' }}>{'(e.g: +1 234 567 0000)'}</span>
                        </label>
                        <PhoneInput
                          className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                            errors.phone && touched.phone ? 'border-red-500' : ''
                          }`}
                          id="phone"
                          name="phone"
                          placeholder="+1 234 567 0000"
                          onChange={(value) => setFieldValue('phone', value || '')}
                          onBlur={(e) => handleBlur(e || '')}
                          value={values?.phone || ''}
                          international
                          defaultCountry={GetFlagCountryCode(site?.address?.country || '') || 'CA'}
                          limitMaxLength={true}
                        />

                        {/* <input
                          className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                            errors.phone && touched.phone ? 'border-red-500' : ''
                          }`}
                          id="phone"
                          name="phone"
                          type="tel"
                          placeholder="Phone Number"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phone}
                        /> */}
                        {site.mandatoryPhoneNumber && !touched.phone && this.state.errorCheck && <p className="text-red-500 font-black text-sm">{errors['phone']}</p>}
                        <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="phone" />
                      </div>
                    )}
                    {(site.thirdPartyCompliance || site.countryDropDown) && !isPurposeOfVisitTypeTemplate && (
                      <div className="mb-4">
                        <label className="block text-sm text-black font-bold mb-2" htmlFor="country">
                          Country Name
                        </label>
                        <Select
                          name="country"
                          id="country"
                          options={COUNTRIES_WITH_CODE.map((c) => {
                            return { label: c.value, value: c.value };
                          })}
                          isMulti={false}
                          onInputChange={this.handleInputChange}
                          onChange={(option) => {
                            let val = undefined;
                            const [country] = COUNTRIES_WITH_CODE.filter((item) => item.value === option.label);
                            this.setState({
                              selectedCountry: country,
                            });
                            val = option.label;
                            let event = { target: { name: 'country', value: val } };
                            handleChange(event);
                            this.hideMenu();
                          }}
                          onBlur={() => {
                            handleBlur({ target: { name: 'country' } });
                            this.hideMenu();
                          }}
                          menuIsOpen={openMenu || false}
                          placeholder="Type and select the country name"
                          styles={{
                            control: (styles) => ({ ...styles, fontSize: 12 }),
                            option: (styles) => ({ ...styles, color: '#000' }),
                          }}
                        ></Select>
                        <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="country" />
                      </div>
                    )}
                    {isPurposeOfVisitTypeTemplate && (
                      <>
                        <div className="mb-4">
                          <label className="block text-sm text-black font-bold mb-2" htmlFor="phone">
                            Phone Number with Country Code <span style={{ color: 'grey' }}>{'(e.g: +1 234 567 0000)'}</span>
                          </label>
                          <PhoneInput
                            className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                              errors.phone && touched.phone ? 'border-red-500' : ''
                            }`}
                            id="phone"
                            name="phone"
                            placeholder="+1 234 567 0000"
                            onChange={(value) => setFieldValue('phone', value || '')}
                            onBlur={(e) => handleBlur(e || '')}
                            value={values?.phone || ''}
                            international
                            defaultCountry={GetFlagCountryCode(site?.address?.country || '') || 'CA'}
                            limitMaxLength={true}
                          />
                          {/* <input
                            className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                              errors.phone && touched.phone ? 'border-red-500' : ''
                            }`}
                            id="phone"
                            name="phone"
                            type="tel"
                            placeholder="Mobile phone number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone}
                          /> */}
                          <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="phone" />
                        </div>

                        <div className="mb-4">
                          <label className="block text-sm text-black font-bold mb-2" htmlFor="email">
                            Email
                          </label>
                          <input
                            className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                              errors.email && touched.email ? 'border-red-500' : ''
                            }`}
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Email address"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                          />
                          <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="email" />
                        </div>

                        {site.displayCompany && (
                          <div className="mb-4">
                            <label className="block text-sm text-black font-bold mb-2" htmlFor="company">
                              Company
                            </label>
                            <input
                              className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                                errors.company && touched.company ? 'border-red-500' : ''
                              }`}
                              id="company"
                              name="company"
                              type="text"
                              placeholder="Company name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.company}
                            />
                            <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="company" />
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {
                    <div id={2} className={'questionPart'}>
                      {isPurposeOfVisitTypeTemplate ? (
                        <div className="text-lg mb-4 text-left">
                          <label className="block text-sm text-black font-bold mb-2" htmlFor="purposeOfVisit">
                            {this.eventId ? 'Choose registration type.' : 'Purpose of visit'}
                          </label>
                          <select
                            name="purposeOfVisit"
                            className={`bg-white shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                              errors.purposeOfVisit && touched.purposeOfVisit ? 'border-red-500' : ''
                            }`}
                            value={this.state.purposeOfVisit}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option>Please select purpose</option>
                            {map(this.state.purposes, (purpose) => (
                              <option key={purpose.id} id={purpose.id} value={purpose.label}>
                                {purpose.label}
                              </option>
                            ))}
                          </select>
                          <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="purposeOfVisit" />
                          {/* <div className="text-lg mb-4 text-center">{values.purposeOfVisit}</div> */}
                        </div>
                      ) : (
                        <>
                          <h1 className="text-lg font-bold text-black text-center mt-4">Who are you visiting?</h1>
                          <br />
                          <div className="mb-4">
                            <label className="block text-sm text-black font-bold mb-2" htmlFor="nameOfHost">
                              Name of host
                            </label>
                            <Select
                              name="nameOfHost"
                              id="nameOfHost"
                              options={this.state.hosts.map((v) => {
                                return { label: v.name, value: v.id };
                              })}
                              isMulti={isPreRegisterWorkFLow}
                              onInputChange={this.handleInputChange}
                              onChange={(option) => {
                                let val = undefined;
                                if (!Array.isArray(option)) {
                                  const [hostDetails] = this.state.hosts.filter((item) => item.name === option.label);
                                  this.setState({
                                    selectedHostDetails: hostDetails,
                                  });
                                  val = option.label;
                                } else {
                                  if (option.length) {
                                    val = option.map((v) => v.label).join(', ');
                                    const [hostDetails] = this.state.hosts.filter((item) => item.name === option[0].label);
                                    this.setState({
                                      selectedHostDetails: hostDetails,
                                      selectedHosts: option.map((v) => v.value),
                                    });
                                  }
                                }
                                let event = { target: { name: 'nameOfHost', value: val } };
                                handleChange(event);
                                this.hideMenu();
                              }}
                              onBlur={() => {
                                handleBlur({ target: { name: 'nameOfHost' } });
                                this.hideMenu();
                              }}
                              menuIsOpen={openMenu || false}
                              placeholder="Type and select the host name"
                              styles={{
                                control: (styles) => ({ ...styles, fontSize: 12 }),
                                option: (styles) => ({ ...styles, color: '#000' }),
                              }}
                            ></Select>
                            {!touched.nameOfHost && this.state.errorCheck && <p className="text-red-500 font-black text-sm">{errors['nameOfHost']}</p>}
                            <ErrorMessage className="text-red-500 font-black text-sm mt-3" component="p" name="nameOfHost" />

                            {/* <Autosuggest
                              suggestions={suggestedHosts}
                              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                              getSuggestionValue={this.getSuggestionValue}
                              onSuggestionSelected={this.onSuggestionChange.bind(this, setFieldValue)}
                              renderSuggestion={this.renderSuggestion}
                              renderInputComponent={renderInputComponent}
                              focusInputOnSuggestionClick={true}
                              inputProps={{
                                id: 'nameOfHost',
                                name: 'nameOfHost',
                                placeholder: 'Type and select the host name',
                                value: values.nameOfHost,
                                onBlur: handleBlur,
                                onChange: handleChange,
                                className: `shadow appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                                  errors.nameOfHost && touched.nameOfHost ? 'border-red-500' : ''
                                }`,
                              }}
                            /> */}
                          </div>
                        </>
                      )}
                    </div>
                  }

                  <GeneralQuestionnaireApp
                    selectedVisitorType={selectedVisitorType}
                    onChange={handleChange}
                    filteredQuestions={filteredQuestions}
                    errors={errors}
                    touched={touched}
                    values={values}
                    pagination={this?.state?.site?.pagination}
                    isEnableIfThenQuestionnaire={this.state?.site?.isEnableIfThenQuestionnaire}
                    fontSize={appFontSize}
                    setFieldValue={setFieldValue}
                    t={t}
                  />

                  <div id={this.state.paginationMax} className={'questionPart'}>
                    {!this.eventId && (
                      <>
                        <img className="visitor-picture-preview" alt="" />
                        <div className={'description'}>
                          <div className={'descriptionBlock'}>
                            <div className={'descriptionTitle text-black'}>I am</div>
                            <div className={'descriptionValue text-black'}>{values.entryType}</div>
                          </div>
                          <div className={'descriptionBlock'}>
                            <div className={'descriptionTitle text-black'}>My name is</div>
                            <div className={'descriptionValue text-black'}>{values.name}</div>
                          </div>

                          {values.company && (
                            <div className={'descriptionBlock'}>
                              <div className={'descriptionTitle text-black'}>I am from</div>
                              <div className={'descriptionValue text-black'}>{values.company}</div>
                            </div>
                          )}
                          {values.email && (
                            <div className={'descriptionBlock'}>
                              <div className={'descriptionTitle text-black'}>Email</div>
                              <div className={'descriptionValue text-black'}>{values.email}</div>
                            </div>
                          )}
                          {values.phone && (
                            <div className={'descriptionBlock'}>
                              <div className={'descriptionTitle text-black'}>Mobile</div>
                              <div className={'descriptionValue text-black'}>{values.phone}</div>
                            </div>
                          )}
                          {this.eventId && (
                            <div className={'descriptionBlock'}>
                              <div className={'descriptionTitle text-black'}>Registration type</div>
                              <div className={'descriptionValue text-black'}>{values.purposeOfVisit}</div>
                            </div>
                          )}
                        </div>
                        {!this.eventId && (
                          <>
                            {isPurposeOfVisitTypeTemplate ? (
                              <div className="text-lg mb-4 text-black text-center">{values.purposeOfVisit}</div>
                            ) : (
                              <div className={'confirmQuestion'}>
                                <div className={'confirmText text-black'}>Are you visiting</div>
                                <div className={'confirmText text-black'}>{values.nameOfHost}?</div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {this.eventId && <div className="text-lg mb-4 text-black text-center">Complete Your Registration.</div>}

                    <div className="flex items-center justify-between">
                      <div onClick={this.onPrevClick} className={'buttonNo bg-blue-500 hover:bg-blue-700 font-bold py-2 px-4 focus:outline-none focus:shadow-outline'}>
                        {'NO'}
                      </div>
                      {
                        <button
                          type="submit"
                          value="Submit"
                          className="buttonYes bg-blue-500 hover:bg-blue-700 font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <div role="status">
                              <svg
                                aria-hidden="true"
                                className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                  fill="currentFill"
                                />
                              </svg>
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            'YES'
                          )}
                        </button>
                      }
                    </div>
                  </div>
                  <div className={'paginationButtons'}>
                    {this.state.selectedStage > 0 && this.state.selectedStage + 1 !== this.state.paginationMax && (
                      <div onClick={this.onPrevClick} id={'buttonPrev'} className={'buttonPagination paginationPrev'}>
                        {t('PREV')}
                      </div>
                    )}
                    {/* {this.state.activeInput} */}
                    {this.state.selectedStage > 0 && this.state.selectedStage + 1 < this.state.paginationMax && (
                      <div
                        onClick={() => {
                          !disabledNext && this.onNextClick(values);
                        }}
                        id={'buttonNext'}
                        className={`buttonPagination paginationNext ${disabledNext ? 'paginationDisabled' : ''}`}
                      >
                        {t('NEXT')}
                      </div>
                    )}
                  </div>
                </Form>
              );
            }

            // FORM WITHOUT PAGINATION
            return (
              <Form
                className={`bg-white px-8 pt-6 pb-8 mb-4`}
                onSubmit={(e) => {
                  e.preventDefault();
                  this.handleFormSubmit(values);
                }}
              >
                <h1 className="text-lg text-black font-bold text-center mt-4">
                  {t('WELCOME TO')}
                  <br />
                  {site.name || ''}
                </h1>
                <div className="p-2">
                  <img className="mx-auto h-24 object-center" src={siteLogoUrl} alt={site.name || ''} />
                </div>

                {!this.eventId && !this.site.mylobbyLite && (
                  <div className="mb-4">
                    <label className="block text-sm text-black font-bold mb-2" htmlFor="country">
                      Step 1: Choose a site
                    </label>
                    <Select
                      value={{ value: site.id, label: site.name }}
                      name="site"
                      options={this.state.sites.map((s) => {
                        return { label: s.name, value: s.id };
                      })}
                      onChange={(option) => {
                        if (option.value !== this.site.id) {
                          this.props.history.push(`/?siteId=${option.value}`);
                          window.location.reload();
                        }
                      }}
                      styles={{
                        singleValue: (provided) => ({
                          ...provided,
                          color: 'white',
                          fontSize: 15,
                          backgroundColor: '#4379bc',
                          fontWeight: 'bold',
                        }),
                        control: (styles) => ({ ...styles, color: 'white', fontSize: 15, backgroundColor: '#4379bc', fontWeight: 'bolder' }),
                        option: (styles) => ({ ...styles, color: 'white', fontSize: 15, backgroundColor: '#4379bc', fontWeight: 'bolder' }),
                      }}
                    />
                  </div>
                )}
                <div className="text-lg text-black mb-4 text-center">
                  <div style={{ fontStyle: 'italic' }}>Ensure your browser can access your camera and upload files.</div>
                  <br />
                  What type of {this.eventId ? 'Event Participant ' : 'visitor '}are you?
                  <br />
                  <br />
                  <label className="block text-sm text-black font-bold mb-2" htmlFor="entryType">
                    {t('Entry Type')}
                  </label>
                  <select
                    name="entryType"
                    className={`bg-white shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                      errors.entryType && touched.entryType ? 'border-red-500' : ''
                    }`}
                    value={this.state.entryType}
                    onChange={this.handleEntryTypeChange.bind(this, setFieldValue, false)}
                    onBlur={handleBlur}
                    id="entryType"
                  >
                    <option>{t('Please select entry type')}</option>
                    {this.state.visitorTypes.map((v) => (
                      <option key={v.roleId} data-visitor-type-role-id={v.roleId} value={v.name}>
                        {v.name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="entryType" />
                </div>

                <div className="mb-4">
                  <label className="block text-sm text-black font-bold mb-2" htmlFor="name">
                    {t('Name')}
                  </label>
                  <input
                    className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                      errors.name && touched.name ? 'border-red-500' : ''
                    }`}
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                  />
                  <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="name" />
                </div>

                {isPurposeOfVisitTypeTemplate ? (
                  // IF WE HAVE PORPOSES OF VISIT
                  <div className="text-lg mb-4 text-left">
                    <label className="block text-sm text-black font-bold mb-2" htmlFor="purposeOfVisit">
                      {/* {t('Purpose of visit')} */}
                      {this.eventId ? 'Choose registration type.' : 'Purpose of visit'}
                    </label>
                    <select
                      name="purposeOfVisit"
                      className={`bg-white shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                        errors.purposeOfVisit && touched.purposeOfVisit ? 'border-red-500' : ''
                      }`}
                      value={this.state.purposeOfVisit}
                      // entryType
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option>{t('Please select purpose')}</option>
                      {map(this.state.purposes, (purpose) => (
                        <option key={purpose.id} id={purpose.id} value={purpose.label}>
                          {purpose.label}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="purposeOfVisit" />
                    {/* <div className="text-lg mb-4 text-center">{values.purposeOfVisit}</div> */}
                  </div>
                ) : (
                  // IF WE DON'T HAVE PORPOSES OF VISIT
                  <>
                    <div className="mb-4">
                      <label className="block text-sm text-black font-bold mb-2" htmlFor="mobilePhoneNumber">
                        {/* {t('Mobile Phone Number')} */}
                        Phone Number with Country Code <span style={{ color: 'grey' }}>{'(e.g: +1 234 567 0000)'}</span>
                      </label>
                      <PhoneInput
                        className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                          errors.phone && touched.phone ? 'border-red-500' : ''
                        }`}
                        id="phone"
                        name="phone"
                        placeholder="+1 234 567 0000"
                        onChange={(value) => setFieldValue('phone', value || '')}
                        onBlur={(e) => handleBlur(e || '')}
                        value={values?.phone || ''}
                        international
                        defaultCountry={GetFlagCountryCode(site?.address?.country || '') || 'CA'}
                        limitMaxLength={true}
                      />
                      {/* <input
                        className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                          errors.phone && touched.phone ? 'border-red-500' : ''
                        }`}
                        id="phone"
                        name="phone"
                        type="tel"
                        placeholder="Mobile phone number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.phone}
                      /> */}
                      <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="phone" />
                    </div>

                    {site.visitor_email ? (
                      <div className="mb-4">
                        <label className="block text-sm text-black font-bold mb-2" htmlFor="email">
                          {t('Email')}
                        </label>
                        <input
                          className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                            errors.email && touched.email ? 'border-red-500' : ''
                          }`}
                          id="email"
                          name="email"
                          type="email"
                          placeholder="Email address"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                        />
                        <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="email" />
                      </div>
                    ) : null}

                    {site.displayCompany && (
                      <div className="mb-4">
                        <label className="block text-sm text-black font-bold mb-2" htmlFor="company">
                          {t('Company')}
                        </label>
                        <input
                          className={`shadow appearance-none text-black border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                            errors.company && touched.company ? 'border-red-500' : ''
                          }`}
                          id="company"
                          name="company"
                          type="text"
                          placeholder="Company name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.company}
                        />
                        <ErrorMessage className="text-red-500 font-black text-sm" component="p" name="company" />
                      </div>
                    )}

                    <div className="mb-4">
                      <label className="block text-sm text-black font-bold mb-2" htmlFor="nameOfHost">
                        Name of host
                      </label>
                      <Select
                        name="nameOfHost"
                        id="nameOfHost"
                        options={this.state.hosts.map((v) => {
                          return { label: v.name, value: v.id };
                        })}
                        isMulti={isPreRegisterWorkFLow}
                        onInputChange={this.handleInputChange}
                        onChange={(option) => {
                          console.log(option);
                          let val = undefined;
                          if (!Array.isArray(option)) {
                            const [hostDetails] = this.state.hosts.filter((item) => item.name === option.label);
                            this.setState({
                              selectedHostDetails: hostDetails,
                            });
                            val = option.label;
                          } else {
                            if (option.length) {
                              val = option.map((v) => v.label).join(', ');
                              const [hostDetails] = this.state.hosts.filter((item) => item.name === option[0].label);
                              this.setState({
                                selectedHostDetails: hostDetails,
                                selectedHosts: option.map((v) => v.value),
                              });
                            }
                          }

                          let event = { target: { name: 'nameOfHost', value: val } };
                          handleChange(event);
                          this.hideMenu();
                        }}
                        onBlur={() => {
                          handleBlur({ target: { name: 'nameOfHost' } });
                          this.hideMenu();
                        }}
                        menuIsOpen={openMenu || false}
                        placeholder="Type and select the host name"
                        styles={{
                          control: (styles) => ({ ...styles, fontSize: 12 }),
                          option: (styles) => ({ ...styles, color: '#000' }),
                        }}
                      ></Select>
                      <ErrorMessage className="text-red-500 font-black text-sm mt-3" component="p" name="nameOfHost" />
                    </div>
                  </>
                )}

                <GeneralQuestionnaireApp
                  selectedVisitorType={selectedVisitorType}
                  onChange={handleChange}
                  filteredQuestions={filteredQuestions}
                  errors={errors}
                  touched={touched}
                  values={values}
                  fontSize={appFontSize}
                  setFieldValue={setFieldValue}
                  t={t}
                />

                <div className="flex items-center justify-between">
                  <button
                    type="submit"
                    value="Submit"
                    className="bg-blue-500 hover:bg-blue-700 font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <div role="status">
                        <svg
                          aria-hidden="true"
                          className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        <span className="sr-only">Loading...</span>
                      </div>
                    ) : (
                      'Submit'
                    )}
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
        <p className="text-center text-gray-500 text-xs">&copy;2020 My Lobby. All rights reserved. App.</p>
      </div>
    );
  }
}

export default withRouter(withTranslation()(App));
